<template>

  <modal :show="isSessionEnd" v-if="isSessionEnd" style="z-index:1100 !important;" body-classes="p-2">
    <div class="d-flex flex-column">
      <div class="p-2 pb-3">
      ログインセッションが終了しました。<br />お手数ですが再度ログインをお願いします。
      </div>
      <base-button type="primary" @click="onClickSessionEnd">ログイン画面に戻る</base-button>
    </div>
  </modal>

  <audio ref="audio1" class="audio-style" />

  <!-- 各画面の表示 -->
  <router-view ></router-view>  
  
  <!-- <div class="wipeArea" ref="wipeArea">
  </div> -->
</template>
<style>
.el-dropdown__popper {
  z-index: 20001 !important;
}
.wipe-menu-zindex{
  z-index:2051 !important;
}
.wipeArea{
  position: fixed;
  right:10px;

}
.startVideoUi{
  position: absolute;
  width:100%;
  height:100%;
  background-color: #333333;
  border-radius: 5px;
  overflow: hidden;
}
.full-video {
  height: 100%;
  width: 100%;
}
@media screen and (min-width:768px) { 
    /* 画面サイズが480pxからはここを読み込む */
  .full-video {
    object-fit: contain;
  }
}
@media screen and (min-width:1024px) and ( max-width:1500px) {
    
  .full-video {
    object-fit: contain;
  }
}
@media screen and (min-width:1500px) {
    /* 画面サイズが1024pxからはここを読み込む */
  .full-video {
    object-fit: contain;
  }
}
.tile-video {
  object-fit: contain;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  vertical-align: middle;
}
.tile-vide-empty {
  background-color: #333333;
  height: 300px;
}
.wipe-video {
  /* border: 1px solid white; */
  /* width: 100%;
        aspect-ratio: 16 / 9; */
  object-fit: contain;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
.video-preview {
  object-fit: contain;
  /* height: 200px;
  width: 200px; */
  /* height: 100%; */
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.no-right-pain {
  width:100%;
  
}
.has-right-pain {
  width:100%;
}
.right-pain{
  width:20%;
  min-width: 250px;
}
.tile-info{
  font-size: 8px;
  bottom:5px;
  position: absolute;
  z-index: 9999 !important;
  color: white;
  width:100%;
  text-align: center;
}
.tile-volume{
  z-index:9999;
  position:absolute !important;
  left:20px;
  top:10px;
  color:#E4007F;
  transition-property: opacity;
  transition-duration: 0.1s;
  transition-timing-function : ease-out;
  opacity: 0;
}
.tileVolumeOn {
  opacity: 1;
}
.tileVolumeOff {
  opacity: 0.3;
}
.pin-btn-off{
  width:30px;
  height:30px;
  position: absolute !important;
  right: 110px;
  top: 5px;
  /* transform: rotate(45deg); */
  /* background-color: transparent; */
  border: 0px;
  color:gray
}
.pin-btn-on{
  width:30px;
  height:30px;
  position: absolute !important;
  right: 0px;
  top: 5px;
  /* transform: rotate(45deg); */
  /* background-color: transparent; */
  border: 0px;
  color:white
}
.audio-style {
  display: none;
}
.display-none {
  display: none;
}
.display-block {
  display: block;
}

</style>
<script>
import { Hub, Logger } from 'aws-amplify';
import UserInfo from "@/appUtils/UserInfo";
import DateUtil from "@/appUtils/DateUtil";
import AppViewModel from "@/AppViewModel"
import { useToast } from "vue-toastification";
import { Auth } from "aws-amplify";
import AuthUtil from "@/appUtils/AuthUtil"

import { 
  DefaultDeviceController,
  DefaultModality,
  DataMessage
} from "amazon-chime-sdk-js";
import ChimeUtil from '@/appUtils/ChimeUtil';
import UserModel from "@/appModel/users/UserModel"

export default {
  components: {
  },
  props: {
    app_vue_test: {
      type: String,
      default: "test"
    },
  },
  data() {
    return {
      isSignIn: false,
      isSessionEnd: false,
      tenantId: "",
      userId: "",
      userName: "",
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      audioInputList: [],
      videoInputList: [],
      speakerOutputList: [],
      audioInput: "",
      videoInput: "",
      speakerOutput: "",
      previewMode: true,
      showMemberPain: false,
      showChatPain: false,
      wipe: {
        isReadyMeeting: false,
        title: "ミーティングを開催",
        width: 240,
        height: 350,
        show: false,
        isPreviewMode: true,
        isMeetingStarted: false,
        isWaitMode: false,
      },
      isStartShare: false,
      meetingChatMessage: "",
      chatList: [],
      bindElement: [],
      tiles: {},
      thumbnailTiles: {},
      mainTileId: null,
      toastId: "App.vue",
      meetingTitle: "",
      currentUserInfo: {
        cognitoId: "",
        userName: "",
        sub: "",
        group: ""
      },
      mainTileAttenndee: null,
      mainTile: null,
      isVideoOff: false,
      isMute: false,
      contentAttenndeeList: []
    }
  },
  mounted(){
    
    /// リリース時にconsole無効化
    const loglevelString = process.env.VUE_APP_LOG_LEVEL
    const logLevelList = { "DEBUG": 0, "INFO": 1, "WARN": 2, "ERROR": 3}
    if (!logLevelList[loglevelString] == 0){
      if (!window.console){
        window.console = {};
      }
      let methods = ["log", "debug", "warn", "info"];
      
      for (let i = 0; i<methods.length; i++){
        console[methods[i]] = function(){};
      }
    }
    
    console.log(`App.vue mouted`)
    this.bindAuthEvent()
  },
  computed: {

    loginWatch() {
      return this.$store.getters.getLoginFlg
    },
    userInfo() {
      return this.currentUserInfo
    },
  },
  watch: {
  },
  methods: {
    /**
     * 認証関係のイベントリスナーを登録する。
     */
    bindAuthEvent() {
      const logger = new Logger(this.$options._componentTag, 'INFO');
      const listener = (data) => {
        switch (data.payload.event) {
        case 'signIn':
          this.isSignIn = true
          logger.info('user signed in');
          // setTimeoutでログイン状態を監視する
          // setTimeout(async function(){
          //   await this.watchSigninSession()
          // }.bind(this), 1000)
          break;
        case 'signUp':
          logger.info('user signed up');
          break;
        case 'signOut':
          // ログアウトを検知
          logger.info('user signed out');
          this.isSignIn = false
          // ミーティング終了
          try {
            this.leaveMeeting()
          } catch (e) {
            console.log(e)
          }
          
          break;
        case 'signIn_failure':
          logger.error('user sign in failed');
          break;
        case 'tokenRefresh':
          logger.info('token refresh succeeded');
          break;
        case 'tokenRefresh_failure':
          logger.error('token refresh failed');
          break;
        case 'configured':
          logger.info('the Auth module is configured');
        }
      }
      Hub.listen('auth', listener);
      
    },
    /**
     * ログインじょうたいを監視する。setTimeoutで再帰呼び出し
     */
    // async watchSigninSession() {
    //   if (this.isSignIn) {
    //     try {
    //       // 
    //       const data = await Auth.currentAuthenticatedUser();
    //       if (!data || !data.signInUserSession) {
    //         this.isSignIn = false
    //       }
    //     } catch (e) {
    //       this.isSignIn = false
    //     }

    //     if (this.isSignIn) {
    //       setTimeout(async function(){
    //         await this.watchSigninSession()
    //       }.bind(this), 1000)
    //     } else {
    //       this.isSessionEnd = true
    //     }

    //   }
    // },
    /**
     * ミーティング終了
     */
    async onClickSessionEnd() {
      // ミーティング終了
      try {
        this.leaveMeeting()
      } catch (e) {
        console.log(e)
      }
      this.isSessionEnd = false
      this.$router.push({
        name: 'Signin'
      })
    },
    /**
     * ログイン情報をセット（ログイン画面から呼び出される）
     */
    setLoginInfo(userInfo) {
      this.currentUserInfo = userInfo
    },
    /**
     * 現在のログインユーザー情報を取得
     */
    async getUserInfo() {
      if (!this.currentUserInfo.sub) {
        console.log(`Cognitoから取得`)
        const userInfo = await UserInfo.getUserInfo()
        this.currentUserInfo = userInfo
      }
      return this.currentUserInfo
    },
    
    
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    },
    createDummyCanvas(name, canvasElement) {
      this.dummyCanvas = this.$refs.dummyAttendee
      let ctx = this.dummyCanvas.getContext('2d');
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, this.dummyCanvas.width, this.dummyCanvas.height);
      ctx.fillStyle = "white";

      ctx.beginPath();
      let fontSize = 24

      ctx.font = "bold " + fontSize + "px Arial, meiryo, sans-serif" ;
      let textWidth = ctx.measureText(name).width;

      ctx.fillText(name, (this.dummyCanvas.width - textWidth) / 2, fontSize)

    },
    /**
     * 各画面から呼び出されるメソッド。
     */
    async validateSession() {
      // ログインセッションチェック
      let userInfo = await this.getUserInfo()

      if (!await AuthUtil.isValidSession(userInfo.group)) {
        // メッセージ表示
        AuthUtil.alert()

        // ログイン画面に戻る
        this.$router.push({
          name: 'Signin'
        })
        return false
      }
      return true
    }
  }
};
</script>
